import $ from 'jquery';
import { updateState, rebind } from '../helpers/custom-elements';
import * as config from '../core/config';

var publicScope = {};
var privateScope = {};
var lightboxConfig = {
  className: '',
  $dialog: {},
  onOpen: null,
  onClose: null
};
var isOpen = false;
var isDomBinded = false;
var selectors = {
  main: '#lightbox',
  content: 'div.lightbox-dialog',
  closeButton: '.lightbox-close',
  dialogBorder: '.lightbox-dialog-border',
  background: '#lightbox-background',
  body: 'body'
};

/**
 * @type {$}
 */
privateScope.$body = null;

/**
 * @type {$}
 */
privateScope.$lightboxContainer = null;

/**
 * @type {$}
 */
privateScope.$background = null;

/**
 * @type {$}
 */
privateScope.$content = null;

/**
 * @return {$}
 */
privateScope.$dialogBorder = null;

/**
 * Method bind private properties to DOM and bind events
 * @return {boolean}
 */
privateScope.bindDom = function() {
  if (isDomBinded) {
    return false;
  }

  privateScope.$background = $(selectors.background);

  $(document).on('keyup.lightboxEvents', privateScope.onEscButtonPress);
  privateScope.$lightboxContainer.on(
    'click.lightboxEvents',
    selectors.closeButton,
    privateScope.onCloseButtonClick
  );
  privateScope.$lightboxContainer.on('click.lightboxEvents', function(event) {
    event.stopPropagation();
  });
  privateScope.$background.on(
    'click.lightboxEvents',
    privateScope.onCloseButtonClick
  );

  isDomBinded = true;

  return true;
};

privateScope.unbindDom = function() {
  $(document).off('.lightboxEvents');
  privateScope.$lightboxContainer.off('.lightboxEvents');
  privateScope.$background.off('.lightboxEvents');
  $(window).off('.lightboxEvents');
  isDomBinded = false;
};

/**
 * @param {Event} event
 */
privateScope.onCloseButtonClick = function(event) {
  event.preventDefault();
  publicScope.close();
};

privateScope.onEscButtonPress = function(event) {
  if (event.keyCode === parseInt(config.get('keyCodes.escape'), 10)) {
    publicScope.close();
  }
};

privateScope.clear = function() {
  privateScope.$lightboxContainer.removeAttr('class');

  return publicScope;
};

privateScope.applyContent = function(html) {
  // privateScope.$content.html(html).parent().show(0, privateScope.adjustWidth);
  privateScope.$content
    .html(html)
    .parent()
    .show(0);
};

privateScope.applyLayout = function() {
  privateScope.clear();
  privateScope.$lightboxContainer.addClass(lightboxConfig.className);
};

privateScope.checkScrollbar = function() {
  var fullWindowWidth = window.innerWidth;

  if (!fullWindowWidth) {
    var documentElementRect = document.documentElement.getBoundingClientRect();

    fullWindowWidth =
      documentElementRect.right - Math.abs(documentElementRect.left);
  }

  this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
  this.scrollbarWidth = this.measureScrollbar();
};

privateScope.setScrollbar = function() {
  var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);

  this.originalBodyPad = document.body.style.paddingRight || '';
  if (this.bodyIsOverflowing)
    this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
};

privateScope.resetScrollbar = function() {
  this.$body.css('padding-right', this.originalBodyPad);
};

privateScope.measureScrollbar = function() {
  var outer = document.createElement('div');

  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.msOverflowStyle = 'scrollbar';

  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;

  // force scrollbars
  outer.style.overflow = 'scroll';

  // add innerdiv
  var inner = document.createElement('div');

  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;

  // remove divs
  outer.parentNode.removeChild(outer);

  return widthNoScroll - widthWithScroll;
};

/**
 * @return {jQuery}
 */
publicScope.getContent = function() {
  privateScope.bindDom();

  return privateScope.$content;
};

/**
 * @return {jQuery}
 */
publicScope.getLightboxContainer = function() {
  privateScope.bindDom();

  return privateScope.$lightboxContainer;
};

/**
 * Method sets configuration of lightbox.
 * Required when .open() method will be called without html parameter
 *
 * @param {Object} c
 * @return {Object}
 */
publicScope.setConfig = function(c) {
  lightboxConfig = $.extend(true, {}, c);

  return publicScope;
};

/**
 * Method closed currently opened lightbox
 * @fires closed.lightbox
 *
 * @return {Object}
 */
publicScope.close = function() {
  if (!isOpen) {
    return publicScope;
  }

  privateScope.unbindDom();

  privateScope.$dialogBorder.css('width', '');
  privateScope.$lightboxContainer.hide();
  privateScope.$background.hide();
  privateScope.clear();
  isOpen = false;

  privateScope.$body.removeClass('lightbox-open');
  privateScope.resetScrollbar();

  if (lightboxConfig.$dialog) {
    lightboxConfig.$dialog.find('[id]').each(function() {
      var $el = $(this);

      $el.prop('id', $el.prop('id').replace('_light_box_masking', ''));
    });
  }

  $.publish('closed.lightbox');

  if (lightboxConfig.onClose && typeof lightboxConfig.onClose === 'function') {
    lightboxConfig.onClose();
  }

  return publicScope;
};

/**
 * Method open lightbox and fills it with content provided in html parameter
 * or based on lightboxConfig.$dialog configuration
 *
 * @param {String=} html
 * @return {Object}
 */
publicScope.open = function(html) {
  if (isOpen) {
    return publicScope;
  }

  var $wrapper = $('<div />');

  privateScope.$body = $(selectors.body);
  privateScope.$lightboxContainer = $(selectors.main);
  privateScope.$dialogBorder = privateScope.$lightboxContainer.find(
    selectors.dialogBorder
  );
  privateScope.$lightboxContainer.find(selectors.content).html($wrapper);
  privateScope.$content = $wrapper;

  privateScope.checkScrollbar();
  privateScope.setScrollbar();
  privateScope.$body.addClass('lightbox-open');

  if (!html) {
    html = lightboxConfig.$dialog.html();

    // changing all IDs in template element to prevent duplicating IDs on one page
    lightboxConfig.$dialog.find('[id]').each(function() {
      var $el = $(this);

      $el.prop('id', $el.prop('id') + '_light_box_masking');
    });
  }

  privateScope.applyLayout();
  privateScope.applyContent(html);

  privateScope.bindDom();

  privateScope.$lightboxContainer.show();
  privateScope.$background.show();

  isOpen = true;

  if (lightboxConfig.onOpen && typeof lightboxConfig.onOpen === 'function') {
    lightboxConfig.onOpen();
  }

  updateState();
  rebind(privateScope.$content);

  return publicScope;
};

publicScope.isOpen = function() {
  return isOpen;
};

export function setConfig(c) {
  return publicScope.setConfig(c);
}

export function open(html) {
  return publicScope.open(html);
}

export function close() {
  return publicScope.close();
}

export function getLightboxContainer() {
  return publicScope.getLightboxContainer();
}

export function getContent() {
  return publicScope.getContent();
}

/**
 * @description passes lightbox to the window
 * currently it's being used by b2b
 * look @https://github.com/Home24/Shop-LandingPages
 * @method exportLightBoxToWindow
 * @returns {undefined}
 */
export function exportLightBoxToWindow() {
  const w = window;

  w.home24 = w.home24 || {};
  w.home24.helpers = w.home24.helpers || {};

  w.home24.helpers.lightbox = publicScope;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/lightbox.js
 **/